<template>
	<div class="page-container">
		<ArticleList :bid="'notice'"></ArticleList>
	</div>
</template>

<script>
import ArticleList from '@/components/Board/articleList'


export default {
	name: 'BoardNotice',
	components: {
		ArticleList
	},
	data () {
		return {
			
		}	
	},
	created: function() {

	},

	mounted() {
	},

}
</script>
